import React from 'react';

export default ({children, label}) => (
  <div className="pagesection">
    <div className="pagesection__container">
      { label &&
       <div className="pagesection__label">
       {label}
       </div>
      }
      <div className="pagesection__content">
        {children}
      </div>
    </div>
  </div>
);




// WEBPACK FOOTER //
// ./src/components/Page/PageSection.jsx